export default "__VITE_ASSET__BpbFNpBm__"